import { useEffect, useMemo, useState } from 'react';
import useBuildVariantProps from '../../../modules/theme/useBuildVariantProps';
import { useSelectContext } from './Select.Context';
import { SelectProps } from './Select.types';

const usePresenter = (props: SelectProps) => {
  const {
    placeholder,
    defaultOpen = false,
    leadingIcon,
    expandIcon,
    state = 'Default',
    menuProps,
    multiple,
    hasDefaultOption,
    className,
    children,
    selectedView: SelectedView,
    popoverOffset = [0, 2],
    ...restProps
  } = props;

  const { selectedValue, resetSelectedValue, disabledField, invalidField, getDisplayLabel } = useSelectContext();

  const [isOpen, setIsOpen] = useState(defaultOpen);

  useEffect(() => {
    setIsOpen(defaultOpen);
  }, [defaultOpen]);

  const onOptionsOpen = () => {
    if (!disabledField) {
      setIsOpen(true);
    }
  };

  const onOptionsClose = () => {
    setIsOpen(false);
  };

  const variantProps = useBuildVariantProps(
    'select',
    {
      type: multiple ? 'multi-select' : 'single-select',
    },
    {
      disabled: disabledField,
      invalid: invalidField || state === 'Error',
    },
  );

  const displayValue = useMemo(() => {
    const label = getDisplayLabel(selectedValue);
    return label || placeholder;
  }, [selectedValue, placeholder, getDisplayLabel]);

  return {
    menuProps,
    popoverOffset,
    hasDefaultOption,
    leadingIcon,
    disabled: disabledField,
    placeholder,
    SelectedView,
    expandIcon,
    variantProps,
    isOpen,
    selectedValue,
    resetSelectedValue,
    triggerProps: restProps,
    onOptionsOpen,
    onOptionsClose,
    displayValue,
    multiple,
  };
};

export default usePresenter;
